<div class="gradient-picker-field">
  <span class="gradient-picker-label">Type</span>
  <div class="gradient-picker-tabs" role="group" aria-label="Fill type">
    <button type="button" [class.active]="value.type === 'solid'" (click)="setMode('solid')">Solid</button>
    <button type="button" [class.active]="value.type === 'linear'" (click)="setMode('linear')">Linear</button>
    <button type="button" [class.active]="value.type === 'radial'" (click)="setMode('radial')">Radial</button>
  </div>
</div>

<div class="gradient-picker-fields">
  @if (value.type === "solid" && showColorFields) {
    <div class="gradient-picker-field">
      <span class="gradient-picker-label">Color</span>
      <app-color-picker [hex]="value.hex" [cmyk]="value.cmyk" [ariaLabel]="ariaLabel" (colorChange)="setSolidColor($event)" />
    </div>
  }

  @if ((value.type === "linear" || value.type === "radial") && showColorFields) {
    <div class="gradient-picker-field">
      <span class="gradient-picker-label">From</span>
      <app-color-picker
        [hex]="value.from.hex"
        [cmyk]="value.from.cmyk"
        ariaLabel="Gradient start color"
        (colorChange)="setFromColor($event)"
      />
    </div>
    <div class="gradient-picker-field">
      <span class="gradient-picker-label">To</span>
      <app-color-picker [hex]="value.to.hex" [cmyk]="value.to.cmyk" ariaLabel="Gradient end color" (colorChange)="setToColor($event)" />
    </div>
  }
</div>

<!-- Its own top-level item (sibling of .gradient-picker-fields, not nested inside it) so it flows
     in DOM order after the color fields and before whatever the caller places after this component
     (e.g. Opacity), packing onto the same line when there's room instead of being trapped inside
     the color fields' own row. -->
@if (value.type === "linear" && showAngle) {
  <div class="gradient-picker-field">
    <span class="gradient-picker-label">Angle</span>
    <mat-slider
      class="gradient-picker-slider"
      discrete
      min="0"
      max="360"
      step="1"
      matTooltip="Gradient angle"
      matTooltipPosition="above"
      matTooltipClass="design-3d-tooltip"
    >
      <input matSliderThumb aria-label="Gradient angle" [ngModel]="value.angle" (ngModelChange)="setAngle($event)" (pointerup)="blurSliderThumb($event)" />
    </mat-slider>
  </div>
}
